import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "toolbar-button-text" }

import vue from '../../../adapter-vue';
import { isH5 } from '../../../utils/env';
import Icon from '../../common/Icon.vue';
import { TUITranslateService, TUIChatService, IConversationModel, TUIStore, StoreName } from '../../../@aidesk/uikit-engine';
import { CUSTOM_MESSAGE_SRC } from '../../../constant';
import { isEnabledMessageReadReceiptGlobal, getTo } from '../../../utils/utils';
interface IProps {
  title?:string;
  icon?:string | undefined;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'toolbar-button-end-human-service',
  props: {
    title: { default: '' },
    icon: { default: '' }
  },
  emits: ['closePopover'],
  setup(__props: any, { emit: __emit }) {

const { ref, onMounted, onUnmounted } = vue;
const currentConversation = ref<IConversationModel>();
const isClicked = ref(false);
const props = __props

const emits = __emit;

onMounted(() => {
  TUIStore.watch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdate,
  });
});

onUnmounted(() => {
  TUIStore.unwatch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdate,
  });
});

const onCurrentConversationUpdate = (conversation: IConversationModel) => {
  currentConversation.value = conversation;
};

const onClick = () => {
  if (isClicked.value || !currentConversation.value) {
    return;
  }
  isClicked.value = true;
  TUIChatService.sendCustomMessage({
    to: getTo(currentConversation.value),
    conversationType: currentConversation.value.type,
    payload: {
      data: JSON.stringify({
        customerServicePlugin: 0,
        src: CUSTOM_MESSAGE_SRC.USER_END_CONVERSATION,
      }),
    },
    needReadReceipt: isEnabledMessageReadReceiptGlobal(),
  },{ onlineUserOnly:true })
  .finally(() => {
    emits('closePopover');
  });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['toolbar-button', _unref(isH5) ? 'toolbar-button-h5' : '', _unref(isClicked) ? 'end-conversation-button-clicked' : '']),
    onClick: onClick
  }, [
    (props.icon)
      ? (_openBlock(), _createBlock(Icon, {
          key: 0,
          class: "toolbar-button-icon",
          file: props.icon,
          width: "14px",
          height: "14px"
        }, null, 8, ["file"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, _toDisplayString(props.title || _unref(TUITranslateService).t('AIDesk.结束会话')), 1)
  ], 2))
}
}

})